import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.56793 1.74179C7.7608 1.41066 8.23918 1.41066 8.43205 1.74179L10.4246 5.1628L14.2939 6.00069C14.6684 6.08179 14.8163 6.53676 14.5609 6.82251L11.9231 9.7747L12.3219 13.7135C12.3605 14.0948 11.9735 14.376 11.6228 14.2215L7.99999 12.625L4.37716 14.2215C4.02649 14.376 3.63947 14.0948 3.67808 13.7135L4.07688 9.7747L1.43904 6.82251C1.18371 6.53675 1.33154 6.08179 1.70607 6.00069L5.57538 5.1628L7.56793 1.74179Z"
            fill="currentColor"
        />
    </svg>
);

export default Icon;
